import { VpSearch, VpSearchField, VpSearchInputWrapper, VpSearchOutput } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import { QuickSearchPanel } from '@/components/QuickSearch'
import { useNavigationHeaderSearch } from './useNavigationHeaderSearch'

interface NavigationHeaderSearchProps {
  currentSeason: string | null
}

export function NavigationHeaderSearch({ currentSeason }: Readonly<NavigationHeaderSearchProps>) {
  const searchInputId = 'navigation-header-search-input'
  const { t } = useTranslation()
  const {
    inputValue,
    shouldOpenSearch,
    onInputChange,
    onInputFocus,
    onSearchClose,
    onPanelClose,
    onSearchSubmit,
  } = useNavigationHeaderSearch(currentSeason)

  const searchPlaceholder = currentSeason
    ? ''
    : t('season-selection.search-disabled-placeholder')
  const searchInputLabel = currentSeason
    ? t('season-selection.search-placeholder')
    : t('season-selection.search-input-label')

  return (
    <VpSearch
      placeholder={searchPlaceholder}
      value={inputValue}
      open={shouldOpenSearch}
      disabled={!currentSeason}
      onChange={onInputChange}
      onFocus={onInputFocus}
      onClose={onSearchClose}
    >
      <form
        role="search"
        aria-label={t('season-selection.search-label')}
        onSubmit={onSearchSubmit}
        data-testid="navigation-header-search-form"
      >
        <VpSearchInputWrapper
          fieldSlot={(
            <VpSearchField
              id={searchInputId}
              aria-label={searchInputLabel}
              name="search"
            />
          )}
        />
      </form>
      <VpSearchOutput>
        {shouldOpenSearch && (
          <QuickSearchPanel
            query={inputValue}
            onClose={onPanelClose}
          />
        )}
      </VpSearchOutput>
    </VpSearch>
  )
}
